import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=0a826ddb&scoped=true&"
import script from "./Callout.vue?vue&type=script&lang=js&"
export * from "./Callout.vue?vue&type=script&lang=js&"
import style0 from "./Callout.vue?vue&type=style&index=0&id=0a826ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a826ddb",
  null
  
)

export default component.exports